"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorGraphic = void 0;
var vector_graphic_1 = require("./vector-graphic");
Object.defineProperty(exports, "VectorGraphic", { enumerable: true, get: function () { return vector_graphic_1.VectorGraphic; } });
//# sourceMappingURL=index.js.map